export default __webpack_public_path__ + "static/media/lsd.2fd3fcb1.jpg";